<template>
  <div class="content">
    <h4 class="card-title text-left">Relatório de Assinatura de Holerites</h4>

    <el-date-picker
      v-model="selectedMonth"
      type="month"
      format="MM/yyyy"
      placeholder="Selecione o mês"
      @change="fetchHolerites"
    />

    <div class="row">
      <!--Campo Funcionario-->
      <div class="col-sm-12 text-left mt-1 form-group has-label">
        <autocomplete
          :search="carregarFuncionario"
          placeholder="Selecionar Funcionário"
          aria-label="Selecionar Funcionário"
          :get-result-value="procurarFuncionario"
          @submit="selecionarFuncionario"
        >
        </autocomplete>
      </div>
    </div>

    <el-table :data="paginatedData" stripe v-loading="loading">
      <el-table-column
        prop="nome"
        label="Nome do Funcionário"
        min-width="200"
      />
      <el-table-column prop="dataEnvio" label="Data de Envio" min-width="100" />
      <el-table-column prop="tipo" label="Tipo" min-width="120" />
      <el-table-column
        prop="dataAtualizacao"
        label="Data de Atualização"
        min-width="150"
      />
      <el-table-column label="Holerite" min-width="150">
        <template #default="scope">
          <el-button type="primary" @click="visualizarHolerite(scope.row)">
            Visualizar PDF
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="Holerite Assinado" min-width="200">
        <template #default="scope">
          <el-button
            :disabled="scope.row.status !== 'Aceito'"
            type="primary"
            @click="visualizarHoleriteAssinado(scope.row)"
          >
            Visualizar PDF Assinado
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="Status" min-width="100">
        <template #default="{ row }">
          <el-tag :type="row.status === 'Aceito' ? 'success' : 'warning'">
            {{ row.status }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="prev, pager, next"
      :total="filteredHolerites.length"
      :page-size="10"
      @current-change="handlePageChange"
    />
  </div>
</template>

<script>
import Fuse from "fuse.js";
import swal from "sweetalert2";

export default {
  data() {
    return {
      holerites: [],
      filteredHolerites: [],
      selectedMonth: null,
      currentPage: 1,
      loading: false,
      funcionarios: [],
      dadosUsuario: "",
      fuseSearch: null,
      id_funcionario: null,
    };
  },
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * 10;
      return this.filteredHolerites.slice(start, start + 10);
    },
  },
  mounted() {
    this.carregarDadosUsuario();
    this.listarFuncionarios();
  },
  watch: {
    id_funcionario() {
      this.fetchHolerites();
    },
  },
  methods: {
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    async fetchHolerites() {
      if (!this.selectedMonth) {
        this.showSwal(
          "auto-close",
          "Erro",
          "Você precisa selecionar o MÊS",
          "error",
        );
        return;
      }
      this.loading = true;
      try {
        const month = `${this.selectedMonth.getFullYear()}-${String(
          this.selectedMonth.getMonth() + 1,
        ).padStart(2, "0")}`;

        const response = await this.axios.post(
          "/api/holerites",
          {
            setDB: this.$cookies.get("db"),
            month,
            relatorio: true,
            funcionario: this.id_funcionario || null,
          },
          {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        );

        this.holerites = response.data.map((item) => ({
          id: item.id,
          cpf: item.empregado_cpf,
          nome: item.nome,
          tipo: item.tipo_holerite || "Mensal",
          dataEnvio: new Date(item.data_insercao).toLocaleDateString("pt-BR"),
          dataAtualizacao: item.data_atualizacao
            ? new Date(item.data_atualizacao).toLocaleDateString("pt-BR")
            : "—",
          status: item.status === 1 ? "Aceito" : "Pendente",
          liberado: item.liberacao === 1,
        }));

        this.filteredHolerites = this.holerites;
      } catch (error) {
        console.error("Erro ao buscar holerites:", error);
      } finally {
        this.loading = false;
      }
    },
    async atualizarLiberacao(holerite) {
      try {
        await this.axios.put(
          `/api/holerites/${holerite.id}`,
          {
            liberado: holerite.liberado,
            setDB: this.$cookies.get("db"),
          },
          {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        );
      } catch (error) {
        console.error("Erro ao atualizar status de liberação:", error);
      }
    },
    async visualizarHolerite(holerite) {
      this.loading = true;
      try {
        const response = await this.axios.post(
          "/api/listaHoleritePorCPF",
          {
            setDB: this.$cookies.get("db"),
            cpf: holerite.cpf,
            tipo_holerite: holerite.tipo,
            isVisualizacao: 1,
            mesReferencia: `${this.selectedMonth.getFullYear()}-${String(
              this.selectedMonth.getMonth() + 1,
            ).padStart(2, "0")}`,
          },
          {
            responseType: "blob",
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        );

        const blob = new Blob([response.data], { type: "application/pdf" });
        const pdfUrl = window.URL.createObjectURL(blob);
        window.open(pdfUrl, "_blank");
      } catch (error) {
        console.error("Erro ao visualizar holerite:", error);
      } finally {
        this.loading = false;
      }
    },
    async visualizarHoleriteAssinado(holerite) {
      this.loading = true;
      try {
        const response = await this.axios.post(
          "/api/listaHoleritePorCPFAssinado",
          {
            setDB: this.$cookies.get("db"),
            cpf: holerite.cpf,
            tipo_holerite: holerite.tipo,
            isVisualizacao: 1,
            mesReferencia: `${this.selectedMonth.getFullYear()}-${String(
              this.selectedMonth.getMonth() + 1,
            ).padStart(2, "0")}`,
          },
          {
            responseType: "blob",
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        );

        const blob = new Blob([response.data], { type: "application/pdf" });
        const pdfUrl = window.URL.createObjectURL(blob);
        window.open(pdfUrl, "_blank");
      } catch (error) {
        console.error("Erro ao visualizar holerite:", error);
      } finally {
        this.loading = false;
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
    },
    listarFuncionarios() {
      let th = this;
      this.loading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        idUsuario: "",
      };

      if (this.dadosUsuario) {
        bodyFormData.idUsuario = this.dadosUsuario.id;
      }

      this.axios
        .post("/api/empregado/listarEmpregados2", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.loading = false;
          th.funcionarios = response.data.data.dados;

          th.fuseSearch = new Fuse(th.funcionarios, {
            keys: ["nome", "cpf"],
            threshold: 0.3,
          });
        })
        .catch((err) => {
          th.loading = false;
        });
    },
    selecionarFuncionario(result) {
      if (result) {
        this.id_funcionario = result.id;
        return result.nome;
      } else {
        return "";
      }
    },
    procurarFuncionario(result) {
      if (result) return result.nome;
      else return "";
    },
    carregarFuncionario(input) {
      if (input.length > 1) {
        return this.fuseSearch.search(input);
      } else {
        this.id_funcionario = null;
        return this.funcionarios;
      }
    },
    carregarDadosUsuario() {
      this.dadosUsuario = this.$cookies.get("usuario") || null;
    },
  },
};
</script>
<style>
.autocomplete-result {
  cursor: default;
  padding: 12px 12px 12px 12px;
  background-image: none;
}

.autocomplete-input {
  height: 38px;
  font-size: 14px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  padding: 12px 12px 12px 12px;
  box-sizing: border-box;
  position: relative;
  line-height: 1.5;
  flex: 1;
  background: #fff;
}
</style>
